import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined'
import { Alert, Button } from 'antd'
import { FlagNode } from 'features/libra/ontology/ontologyFieldTypes'
import { FC } from 'react'
import styled from 'styled-components'

interface FlagNodeRendererProps {
  node: FlagNode
  onContinue: () => void
}

const severityToAlertType = {
  info: 'info',
  warning: 'warning',
  error: 'error',
} as const

export const FlagNodeRenderer: FC<FlagNodeRendererProps> = ({
  node,
  onContinue,
}) => {
  return (
    <Container>
      <StyledAlert
        type={severityToAlertType[node.severity]}
        message={node.name}
        description={node.description}
        showIcon
      />
      <ContinueButton
        type='primary'
        size='large'
        icon={<ArrowRightOutlined />}
        onClick={onContinue}>
        Continue
      </ContinueButton>
    </Container>
  )
}

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`

const StyledAlert = styled(Alert)`
  width: 100%;

  .ant-alert-message {
    font-weight: 600;
    font-size: 16px;
  }

  .ant-alert-description {
    font-size: 14px;
  }
`

const ContinueButton = styled(Button)`
  min-width: 140px;
  height: 44px;
  font-weight: 600;
`
